// One source of truth for redux action type strings.
export const AUTH = {
  LOGIN_REQUEST: 'auth/login_request',
  LOGIN_SUCCESS: 'auth/login_success',
  LOGIN_FAILURE: 'auth/login_failure',
  ME_SUCCESS:    'auth/me_success',
  CAPS_SUCCESS:  'auth/capabilities',
  LOGOUT:        'auth/logout',
};

export const BOOKINGS = {
  LIST_REQUEST: 'bookings/list_request',
  LIST_SUCCESS: 'bookings/list_success',
  LIST_FAILURE: 'bookings/list_failure',
  GET_SUCCESS:  'bookings/get_success',
};

export const USERS_ADMIN = {
  LIST_REQUEST: 'users/list_request',
  LIST_SUCCESS: 'users/list_success',
  LIST_FAILURE: 'users/list_failure',
  UPDATE:       'users/update_one',
  REMOVE:       'users/remove_one',
};

export const INVITES = {
  LIST_REQUEST: 'invites/list_request',
  LIST_SUCCESS: 'invites/list_success',
  LIST_FAILURE: 'invites/list_failure',
  CREATE:       'invites/create',
  UPDATE:       'invites/update',
  REMOVE:       'invites/remove',
};

export const ROLES = {
  LIST_REQUEST: 'roles/list_request',
  LIST_SUCCESS: 'roles/list_success',
  CAPS_SUCCESS: 'roles/capabilities',
  CREATE:       'roles/create',
  UPDATE:       'roles/update',
  REMOVE:       'roles/remove',
};

export const APIKEYS = {
  LIST_REQUEST: 'apikeys/list_request',
  LIST_SUCCESS: 'apikeys/list_success',
  CREATE:       'apikeys/create',
  REMOVE:       'apikeys/remove',
};
